/**
 * Minimalny magazyn w IndexedDB: przeżywa zamknięcie karty, restart tabletu
 * i rozładowaną baterię — w przeciwieństwie do pamięci JS.
 */
const DB_NAME = "bistro-pos";
const DB_VERSION = 1;

let dbPromise: Promise<IDBDatabase> | null = null;

function open(): Promise<IDBDatabase> {
  dbPromise ??= new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains("kv")) db.createObjectStore("kv");
      if (!db.objectStoreNames.contains("outbox")) db.createObjectStore("outbox", { keyPath: "seqNo" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

function wrap<T>(req: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function store(name: "kv" | "outbox", mode: IDBTransactionMode) {
  return (await open()).transaction(name, mode).objectStore(name);
}

export const kv = {
  async get<T>(key: string): Promise<T | undefined> {
    return wrap((await store("kv", "readonly")).get(key));
  },
  async set(key: string, value: unknown): Promise<void> {
    await wrap((await store("kv", "readwrite")).put(value, key));
  },
  async del(key: string): Promise<void> {
    await wrap((await store("kv", "readwrite")).delete(key));
  },
};

export const outboxStore = {
  async all<T>(): Promise<T[]> {
    return wrap((await store("outbox", "readonly")).getAll()) as Promise<T[]>;
  },
  async put(entry: { seqNo: number }): Promise<void> {
    await wrap((await store("outbox", "readwrite")).put(entry));
  },
  async del(seqNo: number): Promise<void> {
    await wrap((await store("outbox", "readwrite")).delete(seqNo));
  },
};
